export default __webpack_public_path__ + "static/media/Bandeau-catalogue-mobile.cbc8d1fc.png";